import Cookies from "js-cookie"

import { generateId } from "../lib/utils"

/**
 * Base class for managing values in storage
 */
class StorageValue {
  key: string
  expires: number

  constructor(key: string, expires = 0) {
    this.key = key
    this.expires = expires
  }

  getValue(): string | null {
    return null
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setValue(value: unknown) {}

  get value() {
    return this.getValue()
  }
  set value(value: unknown) {
    this.setValue(value)
  }
}

/**
 * Base class for managing values in session
 */
class SessionValue extends StorageValue {
  getValue() {
    return sessionStorage.getItem(this.key)
  }

  setValue(value: string) {
    if (!value) sessionStorage.removeItem(this.key)
    else sessionStorage.setItem(this.key, value)
  }
}

class SessionId extends SessionValue {
  generate() {
    return generateId()
  }

  getValue() {
    const value = super.getValue()
    if (!value) this.setValue(this.generate())
    return value
  }
}

/**
 * Base class for managing values in cookies
 */

class CookieValue extends StorageValue {
  getValue() {
    return Cookies.get(this.key)
  }
  setValue(value: string) {
    if (!value) Cookies.remove(this.key)
    else Cookies.set(this.key, value, { expires: this.expires })
  }
}

class CookieId extends CookieValue {
  generate() {
    return generateId()
  }

  getValue() {
    const value = super.getValue()
    if (!value) this.setValue(this.generate())
    return value
  }
}
/**
 * Main Session class for managing various IDs and values
 */
class Session {
  // Searchspring Session Tokens
  pageLoadId
  sessionId
  shopperId
  userId
  isuid
  viewedProducts
  dismissedPopups
  geoCoords
  imageTypeView

  constructor() {
    this.pageLoadId = new SessionId("ssPageLoadId")
    this.sessionId = new SessionId("ssSessionIdNamespace")
    this.userId = new CookieId("ssUserId", 365)
    this.viewedProducts = new CookieValue("ssViewedProducts", 365 * 7)
    this.isuid = new CookieValue("_isuid", 365)
    this.isuid.value = this.userId.value
    this.shopperId = new CookieId("ssShopperId", 365)
    this.geoCoords = new SessionValue("geoCoords")
    this.imageTypeView = new CookieValue("imageTypeView", 365)

    this.dismissedPopups = new SessionId("dismissedPopups")

    if (window.SHOPIFY_DATA.customer) {
      this.shopperId.value = window.SHOPIFY_DATA.customer.id
    }
  }
}

export const session = new Session()
